export const environment = {
  production: true,
  version: "1.0.14",
  apiUrlInterceptVer: "https://saferec.org",
  apiUrl: "https://saferec.org/api",
  googleRecaptcha: "6LcZDg4oAAAAAPtbvJ4m3OwLNHwrNE3NyE3YAay2",
  searchOrigin: ["https://search.saferec.org", "https://recherche.saferec.org"],
  policeOrigin: ["https://police.saferec.org"],
  homeOrigin: "https://saferec.org/",
  defaultLang: "fr",
  OauthCK: true,
};
